exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "nav a[data-v-99fb38ba]{height:43px;border-radius:43px;display:inline-flex;justify-content:center;align-items:center;padding:0 1.5rem;margin:1rem 0}nav a[data-v-99fb38ba]:active,nav a[data-v-99fb38ba]:hover{transition-duration:.3s;transition-property:background-color;background-color:rgba(0,0,0,.2)}nav a[data-v-99fb38ba]:last-child{display:none}", ""]);

// exports
